import React from "react";
import { HelpCircle } from "lucide-react";

const BondPlayStageHeader = ({
  kicker,
  title,
  subtitle,
  helpLabel = "How this game works",
  onOpenInfo,
  children = null,
}) => (
  <div className="bplay-stage-header">
    <div className="bplay-stage-header-main">
      <div className="bplay-stage-header-copy">
        {kicker ? <span className="bplay-stage-header-kicker">{kicker}</span> : null}
        {title ? <h2 className="bplay-stage-header-title">{title}</h2> : null}
        {subtitle ? <p className="bplay-stage-header-sub">{subtitle}</p> : null}
      </div>

      <button
        type="button"
        className="bplay-stage-header-help"
        aria-label={helpLabel}
        onClick={onOpenInfo}
      >
        <HelpCircle size={17} strokeWidth={2.25} />
      </button>
    </div>

    {children}
  </div>
);

export default BondPlayStageHeader;
